const fundingSourceReserve = {
  json: {
    integration: {
      name: '',
      description: '',
      integrationType: 'endNode',
      endNode: {
        endNodeType: 'fundingSourceReserve',
        outputVars: {
          reserveTransactionReference: '',
          reserveResponseCode: '',
        },
      },
    },
    type: 'integration',
  },
  paths: [
    'integration.name',
    'integration.description',
    'integration.endNode.outputVars.reserveResponseCode',
    'integration.endNode.outputVars.reserveTransactionReference',
  ],
  groups: [
    {
      Parameters: [
        'integration.name',
        'integration.description',
        'integration.endNode.outputVars.reserveResponseCode',
        'integration.endNode.outputVars.reserveTransactionReference',
      ],
    },
  ],
  layout: {
    name: {
      type: 'text',
      label: 'Name',
      validators: {
        required: true,
        spaceOnName: true,
      },
    },
    description: {
      type: 'text',
      label: 'Description',
      validators: {
        required: true,
      },
    },
    reserveResponseCode: {
      type: 'text',
      label: 'Funds reserve response code',
      validators: {
        required: true,
      },
    },
    reserveTransactionReference: {
      type: 'text',
      label: 'Funds reserve transaction reference',
      validators: {
        required: true,
      },
    },
  },
};
const fundingSourceConfirm = {
  json: {
    integration: {
      name: '',
      description: '',
      integrationType: 'endNode',
      endNode: {
        endNodeType: 'fundingSourceConfirm',
        outputVars: {
          httpStatus: '',
        },
      },
    },
    type: 'integration',
  },
  paths: [
    'integration.name',
    'integration.description',
    'integration.endNode.outputVars.httpStatus',
  ],
  groups: [
    {
      Parameters: [
        'integration.name',
        'integration.description',
        'integration.endNode.outputVars.httpStatus',
      ],
    },
  ],
  layout: {
    name: {
      type: 'text',
      label: 'Name',
      validators: {
        required: true,
        spaceOnName: true,
      },
    },
    description: {
      type: 'text',
      label: 'Description',
      validators: {
        required: true,
      },
    },
    httpStatus: {
      type: 'text',
      label: 'HTTP status',
      validators: {
        required: true,
      },
    },
  },
};

export const fundingSourceEndNodes: {} = {
  fundingSourceReserve: fundingSourceReserve,
  fundingSourceConfirm: fundingSourceConfirm,
};
